import {BigInput} from "../../forms/bigInput/BigInput";
import {useEffect, useState} from "react";
import useTableData from "../tableContext/useTableData";
import {Input} from "antd";

interface TableInputProps {
    filterKey: string;
}

const TableInput = ({ filterKey }: TableInputProps) => {
    const [value, setValue] = useState('');
    const { filtersBase, filters, setFilters } = useTableData();

    const onChange = (newVal: string) => {
        setValue(newVal);
        setFilters(filters.map(filter => {
            if (filter.filterKey === filterKey) {
                return {...filter, value: newVal || undefined}
            } else {
                return filter;
            }
        }));
    }

    return (
        <Input value={value} onChange={(event) => onChange(event.target.value)} className="table-input" />
    )
}

export default TableInput;